import { MDS_COLORS_INK_STRONG, MDS_COLORS_LINE_BORDER } from '@rappi/mustache-b2b-foundations';
import { Button } from '@rappi/rests-commons-front';
import styled from 'styled-components';
export const ButtonStyled = styled(Button) `
  & > div {
    display: grid !important;
    grid-template-columns: max-content 1fr;
    gap: 8px;

    & > div {
      text-align: left;
      text-wrap: nowrap;
    }
  }

  & > div svg {
    margin-right: 0 !important;
  }
`;
export const customTableStyles = {
    noData: {
        style: {
            padding: '32px',
            minHeight: '350px',
        },
    },
    progress: {
        style: {
            padding: '32px',
            minHeight: '350px',
        },
    },
    table: {
        style: {
            border: `1px solid ${MDS_COLORS_LINE_BORDER}`,
            borderRadius: '8px',
            overflow: 'hidden',
        },
    },
    tableWrapper: {
        style: {
            minHeight: '364px',
        },
    },
    headRow: {
        style: {
            fontSize: '10px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '.12em',
            lineHeight: '24px',
            borderBottom: `1px solid ${MDS_COLORS_LINE_BORDER} !important`,
        },
    },
    headCells: {
        style: { padding: '8px 16px', minHeight: '40px', border: 'none' },
    },
    cells: {
        style: {
            fontSize: '14px',
            lineHeight: '24px',
            color: MDS_COLORS_INK_STRONG,
            padding: '8px 16px',
            border: 'none',
        },
    },
    rows: {
        style: {
            '&:not(:last-of-type)': {
                borderBottom: `1px solid ${MDS_COLORS_LINE_BORDER}`,
            },
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};
export const TableContainer = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  border-radius: 0px;
  min-height: 500px;
`;
